import { FormControl, Modal, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import TopBar from '../../components/Layout/TopBar';
import MyButton from '../../components/Layout/MyButton';
import { faFilePdf, faPaperPlane, faXmark } from '@fortawesome/free-solid-svg-icons';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import { logError } from '../../components/Utils/FormatData';
import { DOCUMENT_TYPE, FACTURATION_TYPE, PARAMETER } from '../../constants/enum';
import { DropzoneAreaBase } from 'material-ui-dropzone';
import { Buffer } from 'buffer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DocumentViewer from '../../components/Dossier/DocumentViewer';

const css = {
  modal: {
    height: '100%',
    width: '100%',
  },
  container: {
    height: '85%',
    width: '90%',
    backgroundColor: 'white',
    borderRadius: '5px',
    margin: 'auto',
  },
};

const ModalEditDevis = (props) => {
  const { openModal, setOpenModal, color, facturation, user, profil, setReloadData } = props;
  const [legalNotice, setLegalNotice] = useState(null);
  const [facturationData, setFacturationData] = useState(facturation);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [viewerFile, setViewerFile] = useState(null);
  const [documents, setDocuments] = useState({
    files: [], initialFiles: []
  });

  const alert = useAlert();
  //#region useEffect
  useEffect(() => {
    if (openModal) {
      if (!facturationData.elements_factures.client) {
        setFacturationData({
          ...facturationData,
          elements_factures: {
            ...facturationData.elements_factures,
            client: {
              orderNumber: '',
              accepted: null,
              comment: '',
            },
          },
        });
      }
      apiGetParameter();
    }
  }, [openModal]);

  useEffect(() => {
    if (facturationData.elements_factures.client) {
      setFacturationData({
        ...facturationData,
        elements_factures: {
          ...facturationData.elements_factures,
          status: {
            ...facturationData.elements_factures.status,
            statutDevis: facturationData.elements_factures.client.accepted ? 'accepted' : 'refused',
          },
        },
      });
    }
  }, [facturationData.elements_factures.client]);

  useEffect(() => {
    let initialFiles = documents.initialFiles ? documents.initialFiles : [];

    if (facturation.id !== 0 && documents.initialFiles === null) {
      documents.files.forEach(function(fileData) {

        let file = dataUriToFile(fileData.data, fileData.fileName, fileData.mimeType);
        file.file = { name: fileData.fileName };
        initialFiles.push(file);

        // On ajoute la propriété id directement sur le fichier pour pouvoir l'identifier plus facilement
        Object.defineProperty(file, 'id', {
          value: fileData.id, writable: true,
        });

        setDocuments({
          ...documents,
          initialFiles: initialFiles,
        });

      });
    } else {
      setDocuments({ ...documents, initialFiles: initialFiles });
    }
  }, [documents.files]);
  //#endregion

  //#region Functions
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleChange = (e, data) => {
    setFacturationData({
      ...data,
      elements_factures: {
        ...data.elements_factures,
        client: {
          ...data.elements_factures.client,
          [e.target.name]: e.target.value,
        },
      },
    });
  };
  //#endregion

  //#region API
  const saveDevis = () => {
    if (facturationData.elements_factures.client.accepted === null) {
      alert.removeAll();
      alert.error('Vous devez accepter ou refuser le devis !');
      return;
    }

    if (facturationData.elements_factures.client.accepted === false && (facturationData.elements_factures.client.comment === null || facturationData.elements_factures.client.comment === '')) {
      alert.removeAll();
      alert.error('Vous devez renseigner la raison du refus !');
      return;
    }

    if (documents.files.length === 0 && facturationData.elements_factures.client.accepted === 'true') {
      alert.removeAll();
      alert.error('Vous devez importer le devis signé !');
      return;
    }

    // if (facturationData.elements_factures.client.orderNumber && facturationData.elements_factures.client.orderNumber.length < 30) {
    //   alert.removeAll();
    //   alert.error('Le numéro de commande client doit contenir au moins 30 caractères !');
    //   return;
    // }

    axios({
      method: 'post',
      url: `${URL_API}/facturation/maj-status-devis`,
      params: {
        id: facturationData.id,
        status: facturationData.elements_factures.client.accepted === 'true' ? 'accepted' : 'refused',
        description: facturationData.elements_factures.client.comment,
        refCommande: facturationData.elements_factures.client.orderNumber,
        userAction: user.user_id
      },
      data: {
        id: 0,
        data: facturationData.elements_factures.client.accepted === 'true' ? documents.files[0].data : '',
        fileName: 'Devis signé n° [' + facturationData.id + ']',
        mimeType: 'application/pdf',
      }
    })
      .then(() => {
        if (facturationData.elements_factures.client.accepted === 'true') {
          alert.success('Le devis a bien été accepté !');
        } else if (facturationData.elements_factures.client.accepted === 'false') {
          alert.success('Le refus de ce devis a été enregistré !');
        }
        if (setReloadData) {
          setReloadData(true);
        }
      })
      .catch((error) => {
        logError(alert, error);
      });
  };

  // TODO: à mettre à jour
  const apiGetParameter = () => {
    axios({
      method: 'get',
      url: `${URL_API}/parameters/get-by-key`,
      params: { key: PARAMETER.LEGAL_NOTICE },
    }).then((response) => {
      setLegalNotice(response.data);
    }).catch((error) => {
      logError(alert, error);
    });
  };

  const handleViewer = (file) => {
    if (file) {
      setViewerFile(file);
      setViewerIsOpen(true);
    }
  };

  const renderDropZonePreview = (file) => {
    if (file.mimeType.split('/')[0] === 'image') {
      let srcData = file.data.includes('data:image') ? file.data : 'data:image/jpeg;base64,' + file.data;

      return (<>
        <div onClick={() => {
          handleViewer(file);
        }}>
          <img className='dropzone-preview-image' role='presentation' src={srcData} />
        </div>
        <label style={{ fontWeight: 'bold' }}>{file.fileName}</label></>);
    }
    if (file.mimeType.split('/')[1] === 'pdf') {
      return (<>
        <div onClick={() => {
          handleViewer(file);
        }}>
          <FontAwesomeIcon icon={faFilePdf}
                           className='dropzone-preview-image'
                           style={{
                             fontSize: '150px',
                           }} />
        </div>
        <label style={{ fontWeight: 'bold' }}>{file.fileName}</label>
      </>);
    }
  };

  const dataUriToFile = (dataUri, filename, mimeType) => {
    let arr = dataUri.split(',');

    let mime = mimeType ? mimeType : arr[0].match(/:(.*?);/)[1];

    let bstr = Buffer.from(arr[1] ?? dataUri, 'base64');

    return new File([bstr], filename, { type: mime });
  };

  const fileToDataUri = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      resolve(event.target.result);
    };
    reader.readAsDataURL(file);
  });

  const onDropZoneAreaChange = async (files, documentType) => {
    let dropZoneDocuments = [];
    setDocuments({ ...documents, files: [] });

    if (files.length > 0) {
      const promises = files.map(fileObject => {
        let file = fileObject.file;

        return fileToDataUri(file).then((base64) => {
          let data = base64.split(',')[1];

          dropZoneDocuments.push({
            id: file.id | 0,
            data: data,
            name: file.name,
            mimeType: file.type,
            documentType: documentType,
            fileName: file.name,
            file: {
              name: file.name,
            },
          });
        });
      });

      await Promise.all(promises);
    }

    if (documentType === DOCUMENT_TYPE.DOCUMENT) {
      setDocuments({ ...documents, files: dropZoneDocuments });
    }
  };

  //#endregion

  return (<>
      {!viewerIsOpen &&
      <Modal open={openModal} style={{ display: 'flex' }} disableEscapeKeyDown={true}>
        <div className='modal' style={css.modal}>
          <div style={css.container}>
            <TopBar title={`DEVIS [N°${facturation.id}] - DOSSIER [N°${facturation.dossier.id}]`}
                    className='topbar-contenu' color={color}
                    buttons={<div className='topbar-buttons'>
                      <MyButton onClick={() => handleCloseModal()} label='Fermer' icon={faXmark} />
                    </div>}
            />
            <div style={{ display: 'flex', padding: '40px', height: 'inherit' }}>
              <div style={{
                width: '40%',
                border: '1px solid rgba(0, 0, 0, 0.23)',
                borderRadius: '30px',
                padding: '20px',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
              }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', overflow: 'auto' }}>
                  <p dangerouslySetInnerHTML={{ __html: legalNotice }}></p>
                </div>
              </div>
              <div style={{ width: '60%', display: 'flex', flexDirection: 'column', padding: '10px', overflowY: 'auto' }}>
                <FormControl>
                  <TextField
                      label='N° de commande client'
                      type='text'
                      name='orderNumber'
                      value={facturationData.elements_factures.client ? facturationData.elements_factures.client.orderNumber : ''}
                      autoComplete='off'
                      onChange={(e) => {
                        handleChange(e, facturationData);
                      }}
                  />
                  <p style={{ textIndent: '50px', fontStyle: 'italic' }}>Si vous voulez qu'un numéro de commande interne
                    soit inscrit sur votre facture, le renseigner ici. Si vous ne connaissez pas encore ce numéro de
                    commande interne, pensez à l'envoyer au service TE avant facturation.</p>
                  <p style={{ textIndent: '50px', fontStyle: 'italic' }}>Le devis téléchargé doit être daté, signé avec la mention "Lu et accepté" puis importé via le bouton ci-dessous.</p>
                </FormControl>
                <FormControl>
                  <RadioGroup
                      name='accepted'
                      value={facturationData.elements_factures.client ? facturationData.elements_factures.client.accepted : null}
                      style={{ display: 'flex', marginLeft: '20px' }}
                      onChange={(e) => {
                      handleChange(e, facturationData);
                    }}
                  >
                    <FormControlLabel value={true}
                                      control={<Radio />}
                                      label='Accepter'
                    />
                    <FormControlLabel value={false}
                                      control={<Radio />}
                                      label='Refuser'
                    />
                  </RadioGroup>
                </FormControl>
                {/*<FormControl>*/}
                {/*  <TextField*/}
                {/*    label='Saisir un commentaire (optionnel)'*/}
                {/*    type='text'*/}
                {/*    name='comment'*/}
                {/*    value={facturationData.elements_factures.client ? facturationData.elements_factures.client.comment : ''}*/}
                {/*    autoComplete='off'*/}
                {/*    multiline*/}
                {/*    maxRows={4}*/}
                {/*    minRows={4}*/}
                {/*    onChange={(e) => {*/}
                {/*      handleChange(e, facturationData);*/}
                {/*    }}*/}
                {/*  />*/}
                {/*</FormControl>*/}
                <div style={{display: 'flex', flexDirection: 'row'}}>
                  <DropzoneAreaBase //masked for readonly because of the trash icon
                      dropzoneClass={'drop-zone-container'}
                      onAdd={(files) => onDropZoneAreaChange(files, DOCUMENT_TYPE.DOCUMENT)}
                      onDelete={(file) => setDocuments({ ...documents, files: [], initialFiles: [] })}
                      acceptedFiles={['image/jpeg', 'image/png', 'application/pdf']}
                      initialFiles={documents.initialFiles}
                      dropzoneParagraphClass={'dropzone-paragraph'}
                      dropzoneText={'Import du devis signé'}
                      maxFileSize={50000000}
                      showPreviews={true}
                      showPreviewsInDropzone={false}
                      getPreviewIcon={renderDropZonePreview}
                      dropzoneProps={{ disabled: false }}
                      filesLimit={1}
                      previewText={'Aperçu:'}
                      showAlerts={false}
                      fileObjects={documents.files}
                  />
                </div>
                <MyButton label={'Envoyer la réponse'}
                          style={'buttonValidation'}
                          sx={{ width: 'max-content', alignSelf: 'center' }}
                          icon={faPaperPlane}
                          onClick={saveDevis}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
      }

      {viewerIsOpen &&
        <DocumentViewer
          setIsOpen={setViewerIsOpen}
          isOpen={viewerIsOpen}
          file={viewerFile}
        />}
    </>
  );

};

export default ModalEditDevis;